// 휴대폰에서 검색 조건을 접어 두는 틀.
//
// 목록 화면의 검색 조건(부서·사원·기간·키워드·검색어 등)이 휴대폰에서는 세로로 쌓여 첫 화면을 다 차지하고,
// 정작 목록은 스크롤 아래에 있었다. 좁은 화면에서는 "검색 조건" 한 줄로 접고
// 누르면 펼친다. 넓은 화면에서는 아무것도 바꾸지 않고 children 을 그대로 그린다.
// (KSM ksm_frontend 의 동일 컴포넌트를 레이아웃만 그대로 포팅함 - 2026-10-20)
import React, { useState } from 'react';
import { Box, Button, Collapse, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TuneIcon from '@mui/icons-material/Tune';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const MobileFilterCollapse = ({ summary, children, defaultOpen = false }) => {
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(defaultOpen);

  if (!isNarrow) return children;

  return (
    <Box sx={{ width: '100%', my: 0.5 }}>
      <Button
        fullWidth
        variant="outlined"
        color="inherit"
        onClick={() => setOpen((v) => !v)}
        startIcon={<TuneIcon fontSize="small" />}
        endIcon={<ExpandMoreIcon sx={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }} />}
        sx={{ justifyContent: 'flex-start', textTransform: 'none', borderColor: 'divider', minHeight: 44 }}
      >
        <Box sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }} component="span">
            검색 조건
          </Typography>
          {summary && (
            <Typography variant="caption" color="text.secondary" component="span" sx={{ ml: 1 }} noWrap>
              {summary}
            </Typography>
          )}
        </Box>
      </Button>
      <Collapse in={open} unmountOnExit={false}>
        <Box sx={{ pt: 1 }}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default MobileFilterCollapse;

// 접힌 줄에 보여 줄 요약: 기간 + 검색어. formik.values 를 그대로 받는다.
export const searchSummary = (values = {}) => {
  const day = (v) => (v ? `${typeof v === 'string' ? v : v?.format?.('YYYY-MM-DD') || ''}`.slice(0, 10) : '');
  const period = values.searchStrtDt || values.searchEndDt ? `${day(values.searchStrtDt)} ~ ${day(values.searchEndDt)}` : '';
  const words = values.searchWords ? `"${values.searchWords}"` : '';
  return [period, words].filter(Boolean).join(' · ');
};
